<template>
  <div class="KYCFAQ">
    <div class="KYCFAQ__title">{{ title }}</div>
    <div class="KYCFAQ__faq-box">
      <div
        v-for="(faq, index) in faqs"
        :key="`${index}`"
        class="KYCFAQ__faq-box-item"
      >
        <div class="KYCFAQ__faq-box-question" @click="faqToggle(index)">
          <div>
            <b>Q.</b>
            {{ faq.question }}
          </div>
        </div>

        <div v-if="faq.is_show" class="KYCFAQ__faq-box-answer">
          <b>A.</b>
          {{ faq.answer }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "KYCFAQ",
  data() {
    return {
      title: "자주하는 질문",
      faqs: [
        {
          question: "고객확인을 하지 않으면 어떻게 되나요?",
          answer:
            "기한 내 고객확인을 완료하지 않을 경우 미체결 주문건이 취소되며, 모든 거래 및 입출금 서비스 이용이 제한됩니다.",
          is_show: false,
        },
        {
          question: "미성년자도 인증이 가능한가요?",
          answer: "19세 미만인 경우 인증이 불가합니다.",
          is_show: false,
        },
        {
          question: "신분증 정보가 틀렸다고 나와요.",
          answer:
            "신분증 인식이 올바르지 않은 경우 정보가 잘못 입력될 수 있습니다. 관련 정보를 직접 수정하여 재입력해 주시기 바랍니다.",
          is_show: false,
        },
        {
          question: "어떤 서류를 준비해야 하나요?",
          answer:
            "개인회원은 본인의 실명확인증표(주민등록증, 운전면허증 등)를 지참하셔야 합니다. 법인의 경우 고객센터로 문의주시기 바랍니다. (문의: help@flybit.com)",
          is_show: false,
        },
        {
          question: "계좌 인증이란?",
          answer:
            "고객확인을 위해 본인 명의의 계좌로 1원을 입금하여 인증을 받는 방법입니다. 사용 가능한 은행 및 증권 본인 계좌로 인증이 가능합니다.",
          is_show: false,
        },
        {
          question: "외국인도 고객확인을 할 수 있나요?",
          answer:
            "외국인 회원은 고객센터로 문의주시기 바랍니다. (문의: help@flybit.com)",
          is_show: false,
        },
        {
          question: "심사가 반려되었어요 어떻게 해야 되나요?",
          answer:
            "심사가 반려된 경우 1:1 문의 또는 카카오톡 채팅으로 문의 바랍니다.",
          is_show: false,
        },
      ],
    };
  },
  methods: {
    faqToggle(index) {
      this.faqs.forEach((faq, faqIdx) => {
        faq.is_show = false;

        if (index === faqIdx) {
          faq.is_show = true;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.KYCFAQ {
  width: 100%;
  margin: 0 auto;
  padding: 60px 16px 120px 16px;

  &__title {
    text-align: center;
    font-size: 24px;
    color: #333;
    font-weight: 500;
  }

  &__faq-box {
    width: 100%;
    margin-top: 28px;
    border-top: 1px solid #e5e5e5;

    &-question {
      border-bottom: 1px solid #e5e5e5;
      padding: 19px 0;
      font-size: 16px;
      color: #222;
      font-weight: 300;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-right: 15px;
      cursor: pointer;
      background: #fff;
    }

    &-answer {
      border-bottom: 1px solid #e5e5e5;
      padding: 18px;
      background: #f7f8fa;
      color: #333;
      word-break: keep-all;
    }
  }
}
</style>
